export const LOGOUT = 'LOGOUT/LOGOUT'

export interface Logout {
  type: typeof LOGOUT
}
